import React, { useEffect, useMemo, useRef, useState } from "react";
import { useFormik } from 'formik';
import { connect } from 'react-redux'
import stateMap from "store/stateMap";
import { SetInitiative, SetInitiativeAccess } from "store/dispatcher";
import "./style.scss";
import fancybox, { popinfo } from "component/Fancybox/Fancybox";
import EditRole, { DeleteRole } from "component/RoleEdit";
import BlockHeader from "component/BlockHeader/BlockHeader";
import api from "api";
import _ from "lodash";
import update from 'immutability-helper';
import { MemberList, MemberList2 } from "component/MemberList";
import ThreeDots from "component/ThreeDots";
import Sidebar from "component/Sidebar";
import "component/FilterBoxes";
import RoleJoinButton, { RolesUpdateRole, RoleTotalRequiredElement } from "component/RoleJoinButton";
import { PageCredential } from "component/PageCredential";

const ShowMemberControl = (props) => {
    const [searchMember, setSearchMember] = useState('');

    const roleArgs = useMemo(() => {
        return {
            search : searchMember
            ,posts_per_page : 9
            ,role_id : props.role.RoleID
        }
    }, [searchMember]);
    
    const formik = useFormik({
        initialValues: {
            search : ''
        }
        ,onSubmit : (values) => {
            setSearchMember(values.search);
        }
    });

    return (
        <div className="popup-manage-member">
            <h1 className="text-lg bold mb-sm">{props.role.RoleName}</h1>
            <span className="block text-sm leading-text block mb-4">{props.role.RoleDesc}</span>
            <form 
                onSubmit={formik.handleSubmit}
                className="generic-form popup-manage-member-search-member">
                    <div className="flex-flat mb-md">
                        <div>
                            <input 
                                type="text"
                                name="search"
                                className="form-control text" 
                                placeholder="Type name.."
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </div>
                        <div>
                            <input type="submit" className="btn btn-orange btn-block" value="Search"/>
                        </div>

                    </div>
            </form>

            
            {
                props.role.TotalApproveRequest > 0 && props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' &&
                <div className="mt-md">
                    <h3 className="text-sm mb-md bold">Member Request</h3>
                    <MemberList
                    membersArgs={roleArgs}
                    buttons={ props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' ? [
                        {
                            key     : 'approve'
                            ,label : 'Approve'
                            ,action : (member) => {
                                return new Promise((resolve) => {
                                    var PopMessage = popinfo('loading', 'Approve Submission', 'Please Wait');
                                    
                                    api('/Role/Permission', 'post', {
                                        role_id : member.RoleID
                                        ,user_id : member.UserID
                                        ,status  : 'approve'
                                    }, 'Bearer ' + props.auth.token)
                                        .then((response) => {
                                            
                                            PopMessage.close();

                                            props.onRoleUpdated.apply(null, [
                                                RolesUpdateRole(props.roles, _.assignIn({}, props.role, update(response.role, {
                                                    TotalApproveRequest : {
                                                        $set : props.role.TotalApproveRequest - 1
                                                    }
                                                }) , {}))
                                            ]);

                                            resolve(update(member, { ApproveDate : {$set : response.change_date}}));

                                        })
                                        .catch((error) => {
                                            popinfo('error', 'Approve Submission' , error, {}, PopMessage);
                                        })
                                });
                            }
                            ,appear : (member) => {
                                return ( member.UserID != props.auth.user.UserID && member.RequiredApproval && !member.ApproveDate);
                            }
                        } 
                        ,{
                            key     : 'decline'
                            ,label : 'Decline'
                            ,action : (member) => {
                                return new Promise((resolve) => {
                                    var PopMessage = popinfo('loading', 'Decline Submission', 'Please Wait');
                                    
                                    api('/Role/Permission', 'post', {
                                        role_id : member.RoleID
                                        ,user_id : member.UserID
                                        ,status  : 'decline'
                                    }, 'Bearer ' + props.auth.token)
                                        .then((response) => {
                                            
                                            PopMessage.close();

                                            props.onRoleUpdated.apply(null, [
                                                RolesUpdateRole(props.roles, _.assignIn({}, props.role, update(response.role, {
                                                    TotalApproveRequest : {
                                                        $set : props.role.TotalApproveRequest - 1
                                                    }
                                                }), {}))
                                            ]);

                                            resolve(update(member, { RejectDate : {$set : response.change_date}}));

                                        })
                                        .catch((error) => {
                                            popinfo('error', 'Decline Submission' , error, {}, PopMessage);
                                        })
                                });
                            }
                            ,appear : (member) => {
                                return ( member.UserID != props.auth.user.UserID && member.RequiredApproval && !member.ApproveDate);
                            }
                        } 
                        ,{
                            key : 'set-admin'
                            ,label : 'Set as Co-Creator'
                            ,action : (member) => {
                                return new Promise((resolve) => {
                                    var PopMessage = popinfo('loading', 'Promoting User', 'Please Wait');
                                    
                                    api('/Role/Promote', 'post', {
                                        user_id : member.UserID
                                        ,initiative_id : props.initiative.initiative.InitiativeID
                                        ,status  : 'promote'
                                    }, 'Bearer ' + props.auth.token)
                                        .then(() => {
                                            
                                            PopMessage.close();

                                            resolve(update(member, { MemberType : {$set : 'admin' }}));

                                        })
                                        .catch((error) => {
                                            popinfo('error', 'Promoting User' , error, {}, PopMessage);
                                        })
                                });
                            }
                            ,appear : member => {
                                return props.initiative.initiative.InitiatorID != member.UserID && member.MemberType != 'admin' && member.ApproveDate;
                            }
                        }
                        ,{
                            key : 'demote-admin'
                            ,label : 'Demote'
                            ,action : (member) => {
                                return new Promise((resolve) => {
                                    var PopMessage = popinfo('loading', 'Demoting User', 'Please Wait');
                                        
                                    api('/Role/Promote', 'post', {
                                        user_id : member.UserID
                                        ,initiative_id : props.initiative.initiative.InitiativeID
                                        ,status  : 'demote'
                                    }, 'Bearer ' + props.auth.token)
                                        .then(() => {
                                            
                                            PopMessage.close();

                                            resolve(update(member, { MemberType : {$set : 'contributor' }}));

                                        })
                                        .catch((error) => {
                                            popinfo('error', 'Demoting User' , error, {}, PopMessage);
                                        })
                                })
                            }
                            ,appear : member => {
                                return props.initiative.initiative.InitiatorID != member.UserID && member.MemberType == 'admin' && member.ApproveDate;
                            }
                        }
                        ,{
                            key     : 'remove'
                            ,label : 'Remove'
                            ,action : (member) => {

                                return new Promise((resolve) => {
                                    var PopMessage = popinfo('loading', 'Removing User', 'Please Wait');
                                    
                                    api('/Role/RemoveMember', 'post', {
                                        role_id : member.RoleID
                                        ,user_id : member.UserID
                                    }, 'Bearer ' + props.auth.token)
                                        .then((response) => {
                                            
                                            PopMessage.close();
                                            
                                            props.onRoleUpdated.apply(null, [
                                                RolesUpdateRole(props.roles, _.assignIn({}, props.role, response.role, {}))
                                            ])

                                            resolve(update(member, { RemoveDate : {$set : response.remove_date}}));

                                        })
                                        .catch((error) => {
                                            popinfo('error', 'Removing User' , error, {}, PopMessage);
                                        })
                                });

                            }
                            ,appear : (member) => {
                                
                                return (member.UserID != props.auth.user.UserID && member.ApproveDate);
                            }
                        } 
                    ] : [] }
                />
                </div>
            }
            <h3 className="text-sm mb-md bold">Participant</h3>
            <MemberList
                membersArgs={roleArgs}
            />
        </div>
    );
}

export default connect( stateMap, {SetInitiative, SetInitiativeAccess} )((props) => {

    const roleListElement                   = useRef(null);
    const [roles, setRoles]                 = useState(false);
    const [filteredRole, setFilteredRole]   = useState(0);
    
    
    const popAddRole = (e) => {
        e.preventDefault();

        const AddRole = fancybox(
            <div>
                <div className="text-center mb-md">
                    <BlockHeader title="Create New Role" desc="Role is ..."/>
                </div>
                <EditRole role={{RoleID : 0, InitiativeID : props.initiative.initiative.InitiativeID}} initiative={props.initiative.initiative} onSave={(editedRole) => {
                    

                    AddRole.close();

                    editedRole.queryparams = {
                        role_id : editedRole.RoleID
                    };
                    
                    editedRole.Display = true;

                    setRoles( update(roles, {
                        $push : [
                            editedRole
                        ]
                    }));
        
                }}/>
            </div>
        )
    };

    const popEditRole = (role) => {

        const FormRole = fancybox(
            <div className="max-w-640">
                <div className="text-center mb-md" key="edit-role-popup-header">
                    <BlockHeader title={role.RoleName} desc="Edit Role"/>
                </div>
                <EditRole  key="edit-role-popup-body" initiative={props.initiative.initiative} role={role} onSave={(editedRole) => {
                    
                    FormRole.close();

                    var index = _.findIndex(roles, { RoleID : editedRole.RoleID});

                    if(index > -1)
                    {
                        editedRole.queryparams = {
                            role_id : editedRole.RoleID
                        };
                        
                        editedRole.Display = true;

                        setRoles(update(roles, {[index] : {$set : editedRole }}));
                    }
        
                }}/>
            </div>
        )   
    }

    const DeletingRole = (role) => {
        var ask = window.confirm('Are You Sure ?');

        if(!ask)
        {
            return;
        }

        var PopMessage = popinfo('loading', 'Deleting Role', 'Please Wait');

        DeleteRole(props.auth.token, role.RoleID, role.InitiativeID)
            .then(() => {
                
                var index = _.findIndex(roles, { RoleID : role.RoleID});

                if(index > -1)
                {
                    setRoles(update(roles, { $splice : [[index, 1]]}));
                }

                popinfo('ok', 'Deleting Role', 'Role Deleted', {}, PopMessage);
            })
            .catch((error) => {
                popinfo('error', 'Deleting Role' , error, {}, PopMessage);
            });
    }

    const JoinLeaveRole = (updatedAccess, updatedRole, currentRole) => {
        props.SetInitiativeAccess(updatedAccess);

        setRoles(RolesUpdateRole(roles, _.assignIn({}, currentRole, updatedRole,  {
            queryparams : {
                role_id : currentRole.RoleID
                ,r      : window.Date.now()
            }
        } )));
    }

    const ExportMemberRole = (role) => {

        let RequestDownload = popinfo('loading', 'Generate Role Member List', 'Please Wait');
            
        api('/Initiative/ExportRoleMembers', 'post', {
            role_id       : role.RoleID
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                RequestDownload.close();
                let element = document.createElement('a');
                element.setAttribute('href', response.url);
                element.setAttribute('download', response.name);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            })
            .catch(error => {
                popinfo('error', 'Generate Role Member List', error, {}, RequestDownload);
            });

    }

    useEffect(() => {
        if(props.initiative.access)
        {
            api('/Role', 'get', {
                initiative_id : props.initiative.initiative.InitiativeID
                ,posts_per_page : -1
                ,need_approvals_attention : 1
            }, 'Bearer ' + props.auth.token)
                .then((response) => {
                    setRoles(_.map(response.roles, (role) => {
                        role.queryparams = {
                            role_id : role.RoleID
                        };
                        
                        role.Display = true;

                        return role;
                    } ));
                });
        }
    }, [props.initiative.access])

    useEffect(() => {
        if(roleListElement.current)
        {
            window.scrollTo(0, roleListElement.current.offsetTop - 60);
        }
    }, [roleListElement.current]);

    return (
        props.initiative.access && 
        <div className="initiative-members container relative" ref={roleListElement}>
            {
                props.initiative.initiative.CurrentStatus != 'recruitment' &&
                <div className="rounded border-solid mb-lg text-sm italic text-center" style={{padding : '16px'}}>
                    Joining the initiative can only be done during the recruitment phase
                </div>
            }
            <PageCredential title={`${props.initiative.initiative.Title} | Member`}/>
            <div className="initiative-members-container">
                <Sidebar>
                    <div className="initiatives-filters filters-boxes">
                        <div className="filter-box">
                            <div className="wrapper">
                                <span className="filter-title">
                                    Roles
                                </span>
                                <div className="filter-body">
                                    <ul className="filter-items">
                                        {
                                            roles !== false && roles.map((role) => (
                                                <li key={role.RoleID} className={`leading-text filter-item ${filteredRole == role.RoleID && 'active' }`}><a href="#" onClick={(e) => {
                                                    e.preventDefault();

                                                    var FilteredRoles = [];

                                                    _.each(roles, (toUpdateRole) => {
                                                        FilteredRoles.push(
                                                            update(toUpdateRole, {
                                                                Display : {$set : filteredRole == role.RoleID ? true : toUpdateRole.RoleID == role.RoleID} 
                                                            })
                                                        );
                                                    });

                                                    setFilteredRole(filteredRole == role.RoleID ? 0 : role.RoleID)

                                                    setRoles(FilteredRoles);

                                                }} >{role.RoleName}</a></li>
                                            ))
                                        }
                                        {
                                            roles === false && <li className="filter-item">
                                                <span className="skeleton"></span>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                {
                                    props.initiative.initiative.InitiativeID 
                                    && props.initiative.access.membership 
                                    && props.initiative.access.membership.MemberType == 'admin' 
                                    && roles !== false 
                                    &&
                                    <>
                                        <hr />
                                        <a href="#" onClick={popAddRole} className="btn btn-primary">Add Role</a>
                                    </> 
                                }
                            </div>
                        </div>
                    </div>
                </Sidebar>
                <ul className="role-lists-compact">
                    {
                        roles !== false && roles.length === 0 &&
                        <div className="block text-center text-lg font-bold mt-md ">
                            No Role Created at the moment
                        </div>
                    }
                    {
                        roles !== false && _.filter(roles, {Display : true}).map((role) => (
                            <li className="role-list-compact" key={role.RoleID}>
                                <div className="wrapper relative">
                                    <div className="column-information column">
                                        <h2 className="role-name text-lg bold leading-tight">{role.RoleName}</h2>
                                        <span className="block text-sm mt-sm"><RoleTotalRequiredElement role={role}/></span>
                                        <div className="role-desc leading-text text-sm mt-sm">{role.RoleDesc}</div>
                                        
                                    </div>
                                    <div className="column-meta colum">
                                        <div className="role-meta-informations">
                                                <ul className="the-metas">
                                                    
                                                    
                                                    {
                                                        role.RoleBGA.length > 0 &&
                                                        <li className="the-meta">
                                                            <span className="meta-symbol">BGA</span>
                                                            <span className="meta-name">
                                                                {
                                                                    props.config.BGA.map((BGA) => (
                                                                        role.RoleBGA.indexOf(BGA[0]) > -1 && <>- {BGA[1]}<br/></>
                                                                    ))
                                                                }
                                                            </span>
                                                        </li>
                                                    }
                                                    {
                                                        parseInt(role.SATPoint) > 0 && 
                                                        <li className="the-meta">
                                                            <span className="meta-symbol">SAT</span>
                                                            <span className="meta-name">{role.SATPoint} SAT Point</span>
                                                        </li>
                                                    }
                                                    <li className="the-meta relative">
                                                        <span className="meta-symbol">Participant</span>
                                                        <div className="relative">
                                                            <a className="column-member-trigger" onClick={e => {
                                                                e.preventDefault();

                                                                fancybox(<ShowMemberControl roles={roles} role={role} initiative={props.initiative} onRoleUpdated={(roles) => {
                                                                    setRoles(roles);
                                                                }}/>)

                                                            }}></a>
                                                            <MemberList2 
                                                                membersArgs={update(role.queryparams, {
                                                                    posts_per_page : {
                                                                        $set : 3
                                                                    }
                                                                    ,is_approve : {
                                                                        $set : 1
                                                                    }
                                                                })}
                                                            />
                                                            {
                                                                role.TotalApproveRequest > 0 && props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' &&
                                                                <span className="member-attention-grabber">!</span>
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                    </div>
                                    <div className="column-action column">
                                        {
                                            props.auth.user && (role.TotalRequired == 0 || role.TotalJoin < role.TotalRequired) && props.initiative.initiative.CurrentStatus == 'recruitment' &&
                                            <RoleJoinButton 
                                                role={role} 
                                                access={props.initiative.access}
                                                onJoin={(updatedAccess, updatedRole) => {
                                                    JoinLeaveRole(updatedAccess, updatedRole, role);
                                                }}
                                                onLeave={(updatedAccess, updatedRole) => {
                                                    JoinLeaveRole(updatedAccess, updatedRole, role);
                                                }}
                                            />
                                        }
                                        {
                                            props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' &&   
                                            <ThreeDots inline={false}>
                                                <button onClick={ (e) => {
                                                    e.preventDefault();

                                                    popEditRole(role);
                                                }}>Edit</button>
                                                <button onClick={ (e) => {
                                                    e.preventDefault();

                                                    DeletingRole(role);
                                                }}>Delete</button>
                                                <button onClick={ (e) => {
                                                    e.preventDefault();

                                                    ExportMemberRole(role);
                                                }}>Export Member</button>
                                            </ThreeDots>
                                        }
                                    </div>
                                </div>
                            </li>
                        ))
                    }
                    {
                        roles === false && 
                        <div className="role-list">
                            <div className="wrapper">
                                <span className="skeleton"></span>
                            </div>
                        </div>
                    }
                </ul>
            </div>
        </div>
    );
});